// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterHeader component
 */

import { FIELDS as fieldsConstants } from 'logic/data/Izenda.ReportDesignerConstants';
import React from 'react';
import classnames from 'classnames';
import CrossFiltering from 'modules/CrossFiltering/Izenda.CrossFiltering';
import connect from 'share/enhancers/Izenda.Connect';
import CrossFilterSetting from 'modules/CrossFiltering/Izenda.CrossFilterSetting';
import constants from 'logic/data/Izenda.ReportsConstants';
import { ACCESS_RIGHT } from 'logic/data/Izenda.AuthorizationConstants';
import ApplyFilterButton from '../../../Reports/Buttons/Izenda.ApplyFilterButton';
import AddFiltersPopup from './Izenda.AddFiltersPopup';
import Button from 'share/components/controls/Izenda.Button';

const FilterHeader = props => {
  const {
    store,
    authorization,
    authorizationConstants,
    collapseToggle,
    openPopup,
    localization,
    updateResultInfo
  } = props;
  let reportFilters = store.reportFilters || {};
  let headerButtonClass = classnames('u_tableCell izenda-FilterHeader__headerButton');

  let showCrossFilteringOption = authorization.checkPrivileges(
    [
      authorizationConstants.PERMISSION_KEY.FullReportAndDashboardAccess,
      authorizationConstants.PERMISSION_KEY.ReportsFilterPropertiesCrossFiltering
    ],
    authorizationConstants.PERMISSION_OPERATOR.Or
  );

  const addNewFilter = () => {
    openPopup(AddFiltersPopup, props);
  };
   
  const onChangeVisible = (e: Object) => {
    reportFilters.setVisible(e.target.checked);
  };

  const onCrossFilteringOptionClick = () => {
    openPopup(CrossFilterSetting, {
      store: store
    });
  };

  const removePill = (pill: Object) => store.removePill.call(store, pill);
  const removeAllPills = () => store.removeAllPills.call(store);
  const resetCrossFilterDefaultValue = () => store.resetCrossFilterDefaultValue.call(store);

  const clearFilter = () =>{
    const {
        reportFilters:{clearFilter},
        reportFilters
    } = store;
    clearFilter.call(reportFilters);
  }

  return (
    <div className='u_table izenda-FilterHeader u_fullWidth'>
      <div className='u_tableCell u_paddingRight u_alignMiddle' onClick={collapseToggle}>
        <i className='icon-toggle-thick' />
        <strong>{fieldsConstants.FILTERS_HEADER_LABEL}</strong>
      </div>
      <div className='u_tableCell u_alignMiddle u_textNoWrap izenda-ShowFilter'>
        <label className='checkbox-inline'>
          <input type='checkbox' checked={reportFilters.visible} onChange={onChangeVisible} />
          {fieldsConstants.SHOW_FILTERS_LABEL}
          <a
            className='icon-info-circled u_alignMiddle'
            title={localization.getText('REPORTDESIGNER_FILTER_SHOW_TOOLTIP')}
          />
        </label>
      </div>
      <div className='u_tableCell u_alignMiddle u_fullWidth izenda-FilterHeader__CrossFilteringContainer'>
        <CrossFiltering
          hadSetting={store.reportBody.hadCrossFilteringSetting}
          crossFilteringDetail={store.reportBody.crossFilteringDetail}
          showCrossFilteringOption={showCrossFilteringOption}
          enableCrossFilteringOption={store.reportBody.enableCrossFiltering}
          enableDeleteAll={store.reportBody.enableDeleteAll}
          removeCrossFiltering={removePill}
          removeAllCrossFiltering={removeAllPills}
          onCrossFilteringOptionClick={onCrossFilteringOptionClick}
          resetDefaultValue={resetCrossFilterDefaultValue}
        />
      </div>
      <div className={headerButtonClass}>
        <button
          className='btn btn-addFilter btn-report-default icon-addnew'
          onClick={addNewFilter}
          title={localization.getText('REPORTDESIGNER_ADD_FILTER_TOOLTIP')}
        />
        {updateResultInfo && updateResultInfo.accessPriority !== ACCESS_RIGHT.Locked && (
          <ApplyFilterButton
            updateResults={updateResultInfo.updateResults}
            disabled={updateResultInfo.doesDisableUpdateResultBtn}
          />
        )}
          <Button
            onClick={clearFilter}
            className='btn-updateResult'>
            <span className='btn-updateResult-label'>{localization.getText('REPORTDESIGNER_LABEL_CLEAR_FILTER')}</span>
          </Button>
      </div>
    </div>
  );
};

export default connect()(FilterHeader);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterHeader.js